import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../../utils/decorators";


@Options({
    template: require("../templates/modal-container.njk"),
    regions: {
        container: ".modal-container",
    },
    ui: {
        close: "[data-js-ui=close-modal]",
        print: "[data-js-ui=print-modal]"
    }
})
export default class BaseModalView extends Marionette.View<Backbone.Model>{

    onAttach() {
        _.delay(_.bind(this.listenForClick, this), 300);
        _.delay(_.bind(this.listenForKeydown, this), 300);
    }

    onRender() {
        $("html").addClass("modal-open");
        this.$el.focus()
    }

    onKeydown(event) {
        if (event.keyCode == 27) {
            this.wantsClose();
        }
    }

    onClick(event) {
        if (!$.contains(this.$el.find(".modal-inner-container").get(0), event.target)) {
            this.wantsClose();
        }
    }

    @on("click @ui.print")
    onPrint() {
        window.print();
    }

    @on("click @ui.close")
    wantsClose() {
        $("html").removeClass("modal-open");
        this.trigger("close")
    }

    listenForClick() {
        $(window).on("click", _.bind(this.onClick, this));
    }

    listenForKeydown() {
        $(window).on("keydown", _.bind(this.onKeydown, this));
    }

    unlistenForClicks() {
        $(window).off("click");
    }

    unlistenForKeydown() {
        $(window).off("keydown");
    }

    onBeforeDetach() {
        this.unlistenForClicks();
        this.unlistenForKeydown();
    }

    onDestroy() {
        $(window).off("keydown")
        $(window).off("click");
    }
}



// WEBPACK FOOTER //
// ./@modules/modals/views/base-modal-view.ts